import { categories } from "@/mocks/gallery";

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-gallery-line"></i>
            Browse Categories
          </span>
          <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            分类鉴赏
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            按你的喜好探索不同风格,找到最戳中你的那一幅。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c, i) => (
            <a
              key={c.name}
              href="#works"
              className="group relative overflow-hidden rounded-lg bg-background-50"
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={
                    i === 0
                      ? "https://readdy.ai/api/search-image?query=soft%20anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20with%20paintbrush%20and%20canvas%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20painterly%20digital%20art%2C%20category%20banner%20thumbnail&width=600&height=450&seq=nami-cat-01&orientation=landscape"
                      : i === 1
                      ? "https://readdy.ai/api/search-image?query=stunning%20anime%20landscape%20wallpaper%20of%20a%20young%20woman%20with%20orange%20hair%20overlooking%20a%20sunny%20ocean%20and%20sails%2C%20high%20resolution%2C%20category%20banner%20thumbnail%2C%20painterly%20digital%20art&width=600&height=450&seq=nami-cat-02&orientation=landscape"
                      : i === 2
                      ? "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20an%20open%20art%20collection%20book%20with%20tangerine%20and%20star%20themed%20pages%2C%20warm%20desk%20lamp%20light%2C%20cozy%20reading%20mood%2C%20category%20banner%20thumbnail%2C%20painterly%20digital%20art&width=600&height=450&seq=nami-cat-03&orientation=landscape"
                      : "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20orange%20hair%20in%20a%20creative%20artist%20studio%20with%20sketches%20and%20tablet%2C%20warm%20cozy%20lighting%2C%20artist%20feature%20mood%2C%20category%20banner%20thumbnail%2C%20painterly%20digital%20art&width=600&height=450&seq=nami-cat-04&orientation=landscape"
                  }
                  alt={`${c.name}·娜美同人分类`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent"></div>
                <span className="absolute bottom-3 left-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                  <i className={c.icon}></i>
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base text-foreground-950">{c.name}</h3>
                  <span className="text-xs text-foreground-500">{c.count} 幅</span>
                </div>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}